import Mekong from "lib/ajax/Mekong";
import { all, call, put, takeLeading } from "redux-saga/effects";
import { __fetchReportConfigurations } from "store/fletcher/sagas";
import { removeItemsFromSelection, setDeleteError, setDeleteLoading } from "./reducers";
import type { PayloadAction } from "@reduxjs/toolkit";

export default function* sagas() {
	yield all([
		takeLeading('report/deleteReportConfigurations', deleteReportConfigurations)
	]);
}

type DeleteReportConifurationsPayload = {
	ids: number[];
};
function* deleteReportConfigurations({ payload: { ids } }: PayloadAction<DeleteReportConifurationsPayload>) {
	yield put(setDeleteLoading(true));
	try {
		yield call([Mekong, 'delete'], `/v1/report/configuration`, { data: { ids } });
		yield put(setDeleteLoading(false));
		yield put(removeItemsFromSelection(ids));
		yield put(setDeleteError(false));
		yield call(__fetchReportConfigurations, true);
	} catch (error: any) {
		yield put(setDeleteError(true));
		yield put(setDeleteLoading(false));
	}
}